import { SUBMISSION__SET, SUBMISSION__SET_NAME } from "@/store/mutation-types";

import SubmissionModel from "@/models/lab/SubmissionModel";

const getStored = (key) => {
  let val = localStorage.getItem(key);
  if (val && val !== "") {
    return val;
  }
  return null;
}
       
const assignModel = (state, key, model) => {
  if (!model || !model.id) {
    model = null;
  }
  state[key] = model;
  if (model) {
    localStorage.setItem(key, JSON.stringify(model._attributes));
  } else {
    localStorage.removeItem(key);
  }
}

const state = {
  submission__current: getStored("submission__current")
    ? new SubmissionModel(JSON.parse(getStored("submission__current")))
    : null,
  submission__name: getStored("submission__name")
    ? getStored("submission__name")
    : null
};

const getters = {
  getCurrentSubmission: state => state.submission__current,
  getCurrentSubmissionName: state => state.submission__name
};

const mutations = {
  SUBMISSION__SET(state, submission) {
    assignModel(state, "submission__current", submission);
  },
  SUBMISSION__SET_NAME(state, submission) {
    state["submission__name"] = submission.publicNumber();
    localStorage.setItem("submission__name", state["submission__name"]);
  }
};

const actions = {
  SUBMISSION__SET_CURRENT: ({ commit }, { submission }) => {
    commit(SUBMISSION__SET_NAME, submission);
    return commit(SUBMISSION__SET, submission);
  },

  async SUBMISSION__FETCH_CURRENT({ commit }, { submission_id }) {
    let submission = new SubmissionModel({ id: submission_id });
    return submission.fetch().then(() => {
      commit(SUBMISSION__SET_NAME, submission);
      return commit(SUBMISSION__SET, submission);
    });
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
